const de = {
    checkout: {
        not_available: '<span>Zahlung</span> nicht möglich',
    },
    payment: {
        loading: 'Zahlung wird vorbereitet',
        another_method: 'Wählen Sie eine andere Zahlungsmethode',
        received: 'Ihre Zahlung wurde erhalten.',
        review: 'Überprüfen Sie Ihre Bestellung',
        total: 'Gesamt',
        choose_method: 'Wählen Sie Ihre Zahlungsmethode',
        description: '*Damit wir Ihr persönliches IQ-Zertifikat erstellen können, werden Sie nach der Zahlung gebeten, Ihren Namen und Ihr Geburtsdatum anzugeben. (Preis inkl. MwSt.)',
        incl_vat: '*Preis inkl. MwSt. Es gelten die',
        terms: 'AGB',
        result: {
            success: 'Zahlung erhalten!',
            error: 'Zahlung fehlgeschlagen! Wählen Sie eine andere Zahlungsmethode und versuchen Sie es nochmal.',
        }
    },
    common: {
        continue: 'Weiter',
        loading: 'DATEN WERDEN VERARBEITET',
        thanks: 'Vielen Dank!'
    },
    error: {
        click_here: 'Klicken Sie hier',
        to_homepage: ', um zur Hauptseite zurückzukehren'
    },
    info: {
        registry: 'Handelsregisternummer',
    },
    nav: {
        home: 'Startseite',
        jobs: 'Jobs',
        about_us: 'Über Uns',
        terms: 'Nutzungsbedingungen',
        gdpr: 'Datenschutz',
        imprint: 'Impressum',
        disclaimer: 'Haftungsausschluss: Unser Ziel ist es, qualitativ hochwertige Programme zur Intelligenzevaluierung und abwechslungsreiche Unterhaltungsprodukte zu entwickeln. Bitte verwenden Sie unsere Inhalte nicht, um wichtige Lebensentscheidungen zu treffen oder sich medizinischen Rat einzuholen.'
    }
};

export default de;
